<template>
  <div class="app-tariff-small-list-element">
    <a class="btn type-details" @click="emitDetailsEvent">
      <div class="bookable-info">
        <span class="bookable-prepend" v-if="info.prepend">{{info.prepend}}</span>
        <div class="bookable-name-container">
          <span class="bookable-name">{{info.name}}</span>
          <span :class="['chevron-container', 'tariff-' + currentTariffId]"><slot name="chevronImg"></slot></span>
        </div>
        <span class="bookable-info-text">{{info.info}}</span>
      </div>
    </a>
    <hr>
  </div>
</template>
<script>

export default {
  name: 'TariffSmallListElement',
  data () {
    return {
      tariff: []
    }
  },
  methods: {
    emitDetailsEvent () {
      this.$emit('details', this.option.tariffoptionId)
    },
    tariffInfo () {
      return {
        name: this.option.name,
        info: this.option.tariffState
      }
    },
    serviceInfo () {
      return {
        name: this.option.tariffExtra.name,
        info: ''
      }
    }
  },
  computed: {
    info: function () {
      if (this.isService) {
        return this.serviceInfo()
      } else {
        return this.tariffInfo()
      }
    }
  },
  props: {
    option: {
      type: Object,
      default: () => {}
    },
    isService: {
      type: Boolean,
      default: false
    },
    currentTariffId: {
      type: String,
      default: '82'
    }
  }
}
</script>
